import { render, staticRenderFns } from "./SeminarItem.vue?vue&type=template&id=66a15b10&scoped=true"
import script from "./SeminarItem.vue?vue&type=script&lang=js"
export * from "./SeminarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a15b10",
  null
  
)

export default component.exports